import { SUPPORT_EMAIL } from '../../constants';

export const LINES_QUERY_ITEM_LIMIT = 30;
export const LINES_PER_PAGE = 6;

export const LINES_NO_LINES_MESSAGE = `No surveys. Currently there are no surveys uploaded for your account.  To resolve this contact support at ${SUPPORT_EMAIL}.`;

export const LINES_NO_LINES_MATCHING_FILTERS_MESSAGE = `There are no surveys matching your filters. Please modify your above filters.`;
